import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=fd6f45c0&scoped=true&"
import script from "./NewUser.vue?vue&type=script&lang=js&"
export * from "./NewUser.vue?vue&type=script&lang=js&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=fd6f45c0&scoped=true&lang=css&"
import style1 from "./NewUser.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6f45c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd6f45c0')) {
      api.createRecord('fd6f45c0', component.options)
    } else {
      api.reload('fd6f45c0', component.options)
    }
    module.hot.accept("./NewUser.vue?vue&type=template&id=fd6f45c0&scoped=true&", function () {
      api.rerender('fd6f45c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuperAdmin/NewUser.vue"
export default component.exports